const NBSP_ENTITY = /&nbsp;/gi
const NBSP_CHAR = /\u00a0/g

/**
 * O conteúdo da Central de Ajuda é escrito no Admin colando texto de editores
 * externos (Word, Google Docs), que trocam **cada** espaço por um espaço
 * inquebrável. Com isso o parágrafo inteiro vira uma única "palavra" para o
 * algoritmo de quebra de linha: o bloco é dimensionado pelo próprio conteúdo
 * (max-content) e vaza para fora do modal em vez de quebrar a linha.
 *
 * Normalizar na renderização mantém o texto legível independentemente de como
 * o conteúdo foi colado no Admin.
 */
export const normalizePostHtml = (html: string): string =>
  html.replace(NBSP_ENTITY, ' ').replace(NBSP_CHAR, ' ')
